import React, { PropsWithChildren, MouseEvent } from 'react';
import {
  Box,
  HStack,
  Icon,
  IconButton,
  Link,
  RemoveAlertDialog,
  ScaleFade,
  useBoolean,
  useDisclosure,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';

interface Props {
  onClick: () => void;
  isActive: boolean;
  hasError?: boolean;
  onRemove?: () => void;
}

const AddInsuranceModalNavigationItem: React.FC<PropsWithChildren<Props>> = ({
  onClick,
  onRemove,
  hasError,
  isActive,
  children,
}) => {
  const { t } = useTranslation();
  const [isHovering, setIsHovering] = useBoolean();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const handleRemove = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onOpen();
  };

  return (
    <>
      <RemoveAlertDialog
        isOpen={isOpen}
        onClose={onClose}
        title={t('ARE-YOU-SURE')}
        description={t(
          'ADVISORY-REPORTS_CURRENT-INSURANCE_MODAL_DETAIL_COVERAGE_REMOVE-ALERT',
          { coverage: children },
        )}
        onConfirm={() => onRemove?.()}
      />
      <HStack onMouseEnter={setIsHovering.on} onMouseLeave={setIsHovering.off}>
        <Link
          as={HStack}
          flexGrow={1}
          variant={!isActive ? 'gray' : undefined}
          onClick={onClick}
        >
          <Box flexGrow={1}>{children}</Box>
          {hasError && (
            <Icon name="GeneralStatusWarningTriangle" color="danger.main" />
          )}
          <ScaleFade initialScale={0.5} in={onRemove && isHovering}>
            <IconButton
              variant="white"
              color="danger.main"
              size="xs"
              onClick={handleRemove}
              icon={<Icon boxSize="16px" name="GeneralActionsThrash" />}
              aria-label="remove coverage"
            />
          </ScaleFade>
        </Link>
      </HStack>
    </>
  );
};

export default AddInsuranceModalNavigationItem;
